__turbopack_context__.v({
  "checkIcon": "LanguageSelectionMenuItem-module__FyiSTG__checkIcon",
  "checkLayer": "LanguageSelectionMenuItem-module__FyiSTG__checkLayer",
  "indicator": "LanguageSelectionMenuItem-module__FyiSTG__indicator",
  "spinnerLayer": "LanguageSelectionMenuItem-module__FyiSTG__spinnerLayer",
});
